<template>
    <transition name="player">
        <div id="mainPlayer" class="playerCont" v-show="show">

            <video :src="videoUrl" ref="video" playsinline></video>

            <loading-indicator name="posts.getVideoUrl"/>

            <pause-overlay :me="video"/>

            <transition name="down">
            <div v-if="showControls" class="controls-cont" @mouseenter="controlsOver" @mouseleave="controlsOut">
                <control-panel :me="video" :post="post" :isMobile="isMobile"/>
            </div>
            </transition>

            <transition name="left">
            <div v-if="hasPlaylist && showControls" class="left" @mouseenter="controlsOver" @mouseleave="controlsOut">
                <a href="#" @click.prevent="prevVideo()"><icon icon="chevron-left" size="2x"/></a>
            </div>
            </transition>

            <transition name="right">
            <div v-if="hasPlaylist && showControls" class="right" @mouseenter="controlsOver" @mouseleave="controlsOut">
                <a href="#" @click.prevent="nextVideo()"><icon icon="chevron-right" size="2x"/></a>
            </div>
            </transition>

            <transition name="up">
            <div v-if="showControls" class="top" @mouseenter="controlsOver" @mouseleave="controlsOut">
                <div class="tbl">
                  <div class="tbl-r">
                    <div v-if="post && showPostTextInfo" class="tbl-c">
                      <a :href="getBlogUrl(post.blog)" @click.prevent="showBlog(post.blog)">
                        <blog-avatar :blog="post.blog" :w="isMobileScreen ? 20 : 30" :h="isMobileScreen ? 20 : 30"/>
                        {{blog.title | maxlen(30)}}
                      </a>
                      via <portal-logo :post="post" :mh="isMobileScreen ? '20px' : '30px'"/>
                      <span class="video-title d-none d-md-inline">{{post.post.title}}</span>
                    </div>
                    <div class="tbl-c actions">
                      <a href="#" @click.prevent="showPostInfo"><icon icon="comment" size="2x"/></a>
                      <share-btn :post="post" size="2x"/>
                      <like-post-button :post="post" size="2x"/>
                      <reblog-btn :post="post" size="2x"/>
                      <a href="#" @click.prevent="hide"><icon icon="times" size="2x"/></a>
                    </div>
                  </div>
                </div>
                <div v-if="post && showPostTextInfo" class="video-title d-md-none">{{post.post.title | maxlen(40)}}</div>
            </div>
              <tiny-progress-bar v-else :me="video"/>
            </transition>

        </div>
    </transition>
</template>

<script>

    import ReblogBtn from '../ui/buttons/ReblogButton.vue';
    import ShareBtn from '../ui/buttons/SharePostButton';
    import Icon from "../ui/Icon";
    import LoadingIndicator from "../ui/LoadingIndicator.vue";
    import ControlPanel from "./ControlPanel.vue";
    import PortalLogo from '../ui/PortalLogo.vue';
    import BlogAvatar from "../ui/BlogAvatar";
    import PauseOverlay from "./PauseOverlay";
    import LikePostButton from "../ui/buttons/LikePostButton";
    import TinyProgressBar from './TinyProgressBar';

    import tools from '../../services/tools'

    export default {
        name: 'Player',
        data() {
            return {
                isMobile: false,
                isMobileScreen: false,
                post: false,
                blog: false,
                video: false,
                show: false,
                videoUrl: '',
                showControls: true,
                canHideControls: true,
                hideControlsDelay: 3000,
                controlsTo: null,
                hasPlaylist: false,
                showPostTextInfo: true
            }
        },
        mounted() {

            this.isMobile = ('ontouchstart' in document.documentElement);
            this.isMobileScreen = (tools.screenSize().width < 768);

            this.video = this.$refs['video'];
            document.getElementById('mainPlayer').onmousemove = this.showControlsAndStartTimer;

            if(this.isMobile){
                document.getElementById('mainPlayer').ontouchstart = this.showControlsAndStartTimer;
            }


            this.$bus.$on('playVideo', (post)=>{

                // TMP PORNHUB FIX
                //if(post.post.host==='pornhub'){
                //  this.$bus.$emit('error', "Sorry, we do have some problems supporting Pornhub videos. We are working hard to fix that.");

                //  setTimeout(()=>{
                //    if(post && this.show) this.$bus.$emit('playNextVideo', post);
                //    this.$bus.$emit('post.deleted', post);
                //  },2000);

                //  return;
                //}
                // TMP PORNHUB FIX

                this.$bus.$emit('modal.open', 'player');
                this.showPostTextInfo = false;
                this.show = true;
                this.showControls = true;
                this.hasPlaylist = false;
                this.$bus.$emit('hasPlaylist', (hasPl)=>{this.hasPlaylist=hasPl});

                this.$api.getVideoUrl(post.post._id).then((res)=>{
                    this.post = post;
                    this.blog = post.blog;
                    this.videoUrl = res.data.url;
                    this.showPostTextInfo = true;
                    setTimeout(()=>this.video.play(),10);
                    this.startControlsHideTime();

                    let postUrl = this.$router.resolve({name:'BlogPageVideo', params:{blogUrl:this.post.blog.url, videoId:this.post._id}});
                    this.$bus.$emit('track.click', {
                       path: postUrl.href,
                       title: 'Play Video'
                    });


                }).catch(()=>{
                    this.$bus.$emit('success', "I will skip it for you!");

                    setTimeout(()=>{
                        if(post && this.show) this.$bus.$emit('playNextVideo', post);
                        this.$bus.$emit('post.deleted', post);
                        this.$bus.$emit('track.click', {
                            path: '/postid/'+post.post._id,
                            title: 'Remove Deleted Video'
                        });
                    },2000);
                })
            })


        },

        methods: {

            hide(){
                this.show = false;
                this.video.pause();
                this.videoUrl = '';
                this.$bus.$emit('modal.close', 'player');
                this.$bus.$emit('player.close');
            },
            reblog(blog){
                this.$api.reblog(blog.url, this.post._id).then((res)=>{
                    this.$bus.$emit('success', 'Reblogged to '+blog.title);
                }).catch((err)=>{

                });
            },
            prevVideo(){
                this.$bus.$emit('playPrevVideo', this.post)
            },
            nextVideo(){
                this.$bus.$emit('playNextVideo', this.post)
            },

            showControlsAndStartTimer(){
                if(!this.showControls) this.showControls = true;
                this.startControlsHideTime();
            },
            startControlsHideTime(){
                if(this.controlsTo) clearInterval(this.controlsTo);
                this.controlsTo = setTimeout(()=>{if(this.canHideControls)this.showControls=false;}, this.hideControlsDelay);
            },
            controlsOver(){
                this.canHideControls = false;
                if(this.controlsTo)clearTimeout(this.controlsTo)
            },
            controlsOut(){
                this.canHideControls = true;
            },

            getBlogUrl(blog){
                return this.$router.resolve({name: 'BlogPage', params:{blogUrl:blog.url}}).href;
            },
            showBlog(blog){
                this.hide();
                if(this.$route.path != this.getBlogUrl(blog)){
                    this.$bus.$emit('blog-modal.open', {blog});
                }
            },
            showPostInfo(){
                this.$bus.$emit('postInspector.show', {post:this.post, theme: 'dark'});
            },

            // Give Feedback that somthing is happening and remove text, but keep ID etc.
            hidePostTextInfos(){

            }
        },
        components:{
          TinyProgressBar,
          LikePostButton,
            PauseOverlay,
            BlogAvatar,
            LoadingIndicator,
            ControlPanel,
            Icon,
            ReblogBtn,
            ShareBtn,
            PortalLogo
        }
    }
</script>

<style lang="sass">

    @import '../../assets/sass/vars.scss'

    .playerCont

        color: #CCC
        text-shadow: #000 0 0 4px

        a
            color: #fff
            opacity: .7

            &:hover
                opacity: 1
                text-decoration: none

        position: fixed
        top: 0
        left: 0
        right: 0
        bottom: 0
        background-color: #000
        z-index: $z-player

        video
            width: 100%
            height: 100%

        .top
            position: absolute
            padding: 20px 20px 12px
            top: 0
            left: 0
            right: 0
            background-color: rgba(0,0,0,.8)

            a
              text-shadow: 0 0 3px rgba(0,0,0,.8)
              margin-left: 10px

            .tbl
              display: table
              width: 100%

            .tbl-r
              display: table-row

            .tbl-c
              display: table-cell

              &.actions
                text-align: right



            @media screen and (max-width: $grid-sm)
              font-size: .8em
              text-align: left

              a
                margin-left: 0

              .tbl-c.actions
                width: 160px

                a
                  font-size: .8em
                  margin-left: 6px



              .video-title
                display: block





        .top, .left, .right
             svg
                 filter: drop-shadow(0px 0px 4px #000)

        .controls-cont
            position: absolute
            bottom: 0
            left: 0
            right: 0

        .left, .right
            position: absolute
            top: 50%
            margin-top: -25px
            height: 50px
            width: 50px

            a
                text-shadow: 0 0 3px rgba(0,0,0,.8)


        .left
            left: 0
            text-align: right

        .right
            right: 0




        .loadingIndicator
            position: absolute
            width: 60px
            height: 60px
            top: 60px
            right: 60px
            left: 60px
            bottom: 120px
            margin: auto
            -webkit-user-select: none
            -moz-user-select: none
            -ms-user-select: none
            user-select: none

            .spinner > div
                background-color: $colorPrimary !important
                box-shadow: 0 0 4px rgba(0,0,0,.5)


        .close
            font-weight: 200
            font-size: 38px
            font-family: 'Helvetica Neue', 'Helvetica'



    .player-enter-active, .player-leave-active
        transition: all .15s ease-out

    .player-enter, .player-leave-to
        opacity: 0
        transform: scale(.75) translateY(100px)


    // Animations
    .up-enter-active, .up-leave-active,
    .left-enter-active, .left-leave-active,
    .right-enter-active, .right-leave-active,
    .down-enter-active, .down-leave-active
        transition: all .3s

    .up-enter, .up-leave-to,
    .left-enter, .left-leave-to,
    .right-enter, .right-leave-to,
    .down-enter, .down-leave-to
        transform: scale(2)
        opacity: 0

    .up-enter, .up-leave-to
        transform: scale(2) translateY(-50px)

    .left-enter, .left-leave-to
        transform: scale(2) translateX(-50px)

    .right-enter, .right-leave-to
        transform: scale(2) translateX(50px)

    .down-enter, .down-leave-to
        transform: scale(2) translateY(50px)

</style>



// WEBPACK FOOTER //
// src/components/player/Player.vue